var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds lds-roller",class:{'lds--fixed':_vm.fixed}},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }